import "./PropertyOverview.css";
import heart from "../../assets/svg/heart icon.svg";
import hill from "../../assets/svg/hill icon.svg";
import check from "../../assets/svg/Check icon.svg";
import { useSelector } from "react-redux";

const PropertyOverview = ({ hotelImages, stayType }) => {
  const { hotelData } = useSelector((state) => state?.hotelInfo);

  const rosaImages = [
    "https://ik.imagekit.io/hotelzifyprod/rosastay-gallery-12_ba03f81c-11ad-44e0-b377-a3286bfd2404.jpg",
    "https://ik.imagekit.io/hotelzifyprod/DJI_0946_cb1db439-da3b-407a-8849-291e9a98468c.jpg",
    "https://ik.imagekit.io/hotelzifyprod/DSC04170-HDR-Enhanced-NR_fb7b2cc9-8086-4f18-ab30-fde1a45f53da.jpg",
    "https://ik.imagekit.io/hotelzifyprod/DSC04077-HDR-Enhanced-NR_7cb3d7b4-b533-4794-9a92-499ba5d20d43.jpg",
  ];

  const rosaImageText = [
    "Private Pool",
    "Luxurious Villa",
    "Ocean Views",
    "Portuguese Style Interior",
  ];

  const sterlingKodaiValleyImages = [
    "https://ik.imagekit.io/hotelzifyprod/0f6f1320c90f11e7b1e702b3e31a734a_2089db15-fbb5-4a4c-b09a-20c45efa18d3.avif",
    "https://ik.imagekit.io/hotelzifyprod/ex_5cd9532d-7b90-421d-bfca-4facd55b308f.webp",
    "https://ik.imagekit.io/hotelzifyprod/e23091ee86a011e48610daf4768ad8d9_58f92116-bda5-48cd-8111-3090fb5bafc0.avif",
    "https://ik.imagekit.io/hotelzifyprod/37766c0086a111e492be32e76f7e45c9_5f95928b-5986-4c2c-a22c-2d8b5343407a.webp",
  ];

  const sterlingKodaiValleyImagesText = [
    "Fine Dining",
    "Valley Views",
    "Welness Spa",
    "Play Area & Activities",
  ];

  let stay;
  if (!["GENERAL", "COUPLE", "LUXURY", "FAMILY"].includes(stayType)) {
    return;
  } else {
    stay = stayType;
  }

  if (hotelData?.id === 27473 && stay === "GENERAL") return;

  //for sterling kodai valley
  const leftFeatures = [
    "Stunning Valley Views",
    "Sterling Hospitality",
    "24/7 Room Service",
    "Multi-dining Options",
    "And more to love",
  ];

  const GeneralThingstoDo = [
    "Scenic Nature Walks",
    "Boating at Kodaikanal Lake",
    "Trek to Dolphin’s Nose",
    "Bonfire & Stargazing",
    "And more things..",
  ];

  const FamilyThingstoDo = [
    "Nature Walk & Picnic",
    "Boating at Kodaikanal Lake",
    "Fun at Bryant Park",
    "Bonfire & Stargazing",
    "And more things..",
  ];

  const RomanticThingstoDo = [
    "Private Candlelight Dinner",
    "Bonfire under starlit sky",
    "Trek to Dolphin’s Nose",
    "Couple Spa Retreat",
    "And more things..",
  ];

  const LuxuryThingstoDo = [
    "Chauffeur-Guided Tour",
    "Gourmet Dining Experience",
    "Sunset High-Tea",
    "Spa & Wellness Therapy",
    "And more things..",
  ];

  const thingsToDoMap = {
    GENERAL: GeneralThingstoDo,
    FAMILY: FamilyThingstoDo,
    COUPLE: RomanticThingstoDo,
    LUXURY: LuxuryThingstoDo,
  };

  const ThingsToDo = thingsToDoMap[stay] || GeneralThingstoDo;

  //for rosa stays
  const WhatYouWillLove_Family = [
    "Elegant Portuguese-style Heritage Stay",
    "Cozy & Spacious Family Rooms",
    "Delicious Goan & Multi-cuisine Delights",
    "Pet-friendly Property",
    "Warm Hospitality with a Local Touch",
    "Peaceful Courtyard & Lounge Spaces",
  ];

  const WhatYouWillLove_Couples = [
    "Charming Portuguese-Style Hideaway",
    "Intimate Courtyard & Cozy Balconies",
    "Elegant Rooms with Old-World Charm",
    "In-room Dining for Private Meals",
    "Peaceful, Laid-back Ambience",
    "Relaxing Dips in the Poolside Oasis",
  ];

  const WhatYouWillLove_Luxury = [
    "Heritage Living with Modern Luxury",
    "Curated Interiors & Vintage Decor",
    "Outdoor Swimming Pool for Refreshing Breaks",
    "Bespoke Service, Personalized for You",
    "Premium Comfort in Every Room",
    "And indulgence in every detail",
  ];

  const rosaStayLeftFeaturesMapData = {
    FAMILY: WhatYouWillLove_Family,
    COUPLE: WhatYouWillLove_Couples,
    LUXURY: WhatYouWillLove_Luxury,
  };

  const RosaStayLeftFeats = rosaStayLeftFeaturesMapData[stay];

  const RosaFamilyThingstoDo = [
    "Family Walks through Fontainhas Heritage Streets",
    "Beach Day at Miramar & Dona Paula",
    "River Cruise with Live Entertainment",
    "Art & Culture Tour in Old Goa",
    "Discover Portuguese-Era Streets of Fontainhas",
    "Sunset Cruise on the Mandovi River",
  ];

  const RosaCouplesThingstoDo = [
    "Sunset Walks by the Beach",
    "Romantic River Cruise on Mandovi",
    "Couple Spa Sessions Nearby",
    "Discover Fontainhas – Hand-in-Hand",
    "Poolside Lounging with Your Favorite Drink",
    "And endless moments for two…",
  ];

  const RosaLuxuryThingstoDo = [
    "Guided Heritage Walks with Locals",
    "Private Yacht or River Cruise Experiences",
    "Relax by the Pool After Exploring Goa",
    "Explore Art Galleries & Boutiques",
    "Dine at High-end Cafés & Restaurants",
    "And unique moments that define luxury...",
  ];

  const RosathingsToDoMap = {
    FAMILY: RosaFamilyThingstoDo,
    COUPLE: RosaCouplesThingstoDo,
    LUXURY: RosaLuxuryThingstoDo,
  };

  const RosaThingstoDo = RosathingsToDoMap[stay];

  return (
    <div className="parent">
      <div className="container">
        {stay === "COUPLE" || stay === "LUXURY" || stay === "GENERAL" ? (
          <p className="Maintext">
            Your{" "}
            <span
              style={{ marginLeft: "2px", marginRight: "2px" }}
              className="highlight-section"
            >
              {stay === "COUPLE" ? (
                <i className="bold" style={{ color: "var(--blue)" }}>
                  Romantic Escape
                </i>
              ) : stay === "LUXURY" ? (
                <i className="bold" style={{ color: "var(--blue)" }}>
                  Luxury Escape
                </i>
              ) : stay === "GENERAL" ? (
                <i className="bold" style={{ color: "var(--blue)" }}>
                  Ultimate Escape
                </i>
              ) : null}
              <svg width="130" height="10" className="underline">
                <path
                  d="M0,7 Q65,2 130,7"
                  stroke="#FFD700"
                  strokeWidth="2"
                  fill="none"
                />
              </svg>
            </span>{" "}
            amidst the hills
          </p>
        ) : (
          <p className="Maintext">
            <span style={{ marginRight: "2px" }} className="highlight-section">
              <i className="bold" style={{ color: "var(--blue)" }}>
                Fun Filled
              </i>

              <svg width="90" height="10" className="underline">
                <path
                  d="M0,7 Q65,2 130,7"
                  stroke="#FFD700"
                  strokeWidth="2"
                  fill="none"
                />
              </svg>
            </span>{" "}
            adventures for your family
          </p>
        )}
      </div>

      <div className="secondContainer">
        <div className="imageWrapper">
          {hotelData?.id === 5153 &&
            sterlingKodaiValleyImages?.map((image, index) => {
              return (
                <div className="imageItem" key={index}>
                  <img src={image} alt="Hotel Image" />
                  <div className="imageText">
                    <p>{sterlingKodaiValleyImagesText[index] || ""}</p>
                  </div>
                </div>
              );
            })}
          {hotelData?.id === 27473 &&
            rosaImages?.map((image, index) => {
              return (
                <div className="imageItem">
                  <img src={image} alt="Hotel Image" />
                  <div className="imageText">
                    <p>{rosaImageText[index] || ""}</p>
                  </div>
                </div>
              );
            })}
        </div>
        <div className="bottomofsecondcontainer">
          <div className="specialities">
            <div className="leftspecialities">
              <img
                style={{ width: "25px", height: "25px", borderRadius: "50%" }}
                src={heart}
                alt="icon"
              />
              <p>What You"ll Love Here</p>
              <hr
                style={{
                  width: "100%",
                  height: "1px",
                  backgroundColor: "#E9EAEB",
                }}
              />
              <div className="feature-list">
                {/* Kodai Valley */}
                {hotelData?.id === 5153 &&
                  leftFeatures?.map((feature, index) => (
                    <div key={index} className="feature-item">
                      {/* <span className="checkmark">✓</span> */}
                      <span className="checkmark">
                        <img src={check} />
                      </span>
                      <p>{feature}</p>
                    </div>
                  ))}

                {/* Rosa Stays */}
                {hotelData?.id === 27473 &&
                  RosaStayLeftFeats?.map((feature, index) => (
                    <div key={index} className="feature-item">
                      {/* <span className="checkmark">✓</span> */}
                      <span className="checkmark">
                        <img src={check} />
                      </span>
                      <p>{feature}</p>
                    </div>
                  ))}
              </div>
            </div>
            <div className="rightspecialities">
              <img
                style={{
                  width: "19px",
                  height: "19px",
                  borderRadius: "50%",
                }}
                src={hill}
              />
              <p>Things to do</p>
              <hr
                style={{
                  width: "100%",
                  height: "1px",
                  backgroundColor: "#E9EAEB",
                  marginTop: "2px",
                }}
              />
              <div className="feature-list">
                {/* Kodai Valley */}
                {hotelData?.id === 5153 &&
                  ThingsToDo?.map((feature, index) => (
                    <div
                      key={index}
                      className="feature-item"
                      style={{ paddingLeft: "15px" }}
                    >
                      <span className="checkmark">
                        <img src={check} alt="checkmark" />
                      </span>
                      <p>{feature}</p>
                    </div>
                  ))}

                {/* Rosa Stay */}
                {hotelData?.id === 27473 &&
                  RosaThingstoDo?.map((feature, index) => (
                    <div
                      key={index}
                      className="feature-item"
                      style={{ paddingLeft: "15px" }}
                    >
                      <span className="checkmark">
                        <img src={check} alt="checkmark" />
                      </span>
                      <p>{feature}</p>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyOverview;
